import { storeToRefs } from 'pinia'
import { type Ref, computed } from 'vue'
import { getAppConfig, isNonProdEnv } from '@/libs/config/config'
import { useFlagStore } from '@/libs/flags'
import { BannerStatus, ProductWarningConfig } from './types'

/**
 *
 */
export function setup(): {
  BannerStatus: typeof BannerStatus
  devWarning: Ref<string>
  productWarningConfig: Ref<ProductWarningConfig | null>
} {
  const { showAppBanner } = storeToRefs(useFlagStore())

  const getProductBannerStyles = (status?: BannerStatus) => {
    switch (status) {
      case BannerStatus.INCIDENT:
      case BannerStatus.INFO:
      default: {
        return 'bg-nash-mustard600 text-nash-mustard700'
      }
    }
  }

  const getProductBannerIcon = (status?: BannerStatus) => {
    switch (status) {
      case BannerStatus.INCIDENT: {
        return 'exclamationCircle'
      }
      case BannerStatus.INFO:
      default: {
        return 'infoNotification'
      }
    }
  }

  const productWarningConfig = computed(() => {
    if (showAppBanner.value) {
      const message = showAppBanner.value.message
      const status = showAppBanner.value.status

      return {
        icon: getProductBannerIcon(status),
        message,
        styles: getProductBannerStyles(status),
      }
    }
    return null
  })

  const devWarning = computed(() => {
    if (!isNonProdEnv()) {
      return ''
    }

    const config = getAppConfig()
    return `You are in the ${config.env} environment.`
  })

  return {
    BannerStatus,
    devWarning,
    productWarningConfig,
  }
}
